module.exports = __webpack_public_path__ + "img/image49.b012e169.png";